import { useSelector } from 'react-redux';
import { userSelectors } from '@/Redux/User';
import { UserSegmentType } from '@/Enums';

export function useUserHasBusinessSegment() {
  const user = useSelector(userSelectors.currentUser);

  return user?.segment === UserSegmentType.BusinessUser;
}
